module.exports = __webpack_public_path__ + "img/KN.41671d37.png";